import validation from '../../../../../../modules/Gull/Framework/validation.js';

const toevoegenVanHisPolis = {

	init() {

		// Unbind gebruikelijke submit functie en creeer nieuwe submit die via modal verloopt
		$('form[data-validate]').attr('data-validate-onsubmit-disabled', true);
		$('form[data-validate]').submit(async function() {
			let validated = await validation.checkSubmitForm(this);
			if (validated) {
				$('#loadingModal').modal('show', {
					backdrop: 'static',
					keyboard: false
				});
				setTimeout(function() {
					$('form[data-validate]').unbind('submit');
					$('form[data-validate]').submit();
				}, 1000);
				//
			}
			return false;
		});

		// Toon en verberg gevonden afstandsverklaringen als begindatum gewijzigd wordt
		$('#Begindatum').change(function(e) {
			e.preventDefault();
			if (($('#Begindatum').val() != '')) {
				$.getJSON(window.app.ajaxPath + $('#form-afstandsverklaring').data('werknemer_id') + '/' + $('#form-afstandsverklaring').data('administratie_hispolis_id') + '/duplicate-check/' + $('#Begindatum').val() + '/' + '/', function(data) {
					if (data != false) {
						// Er is een overlappend salaris
						if (!$('#form_suggestion').is(':visible')) {
							$('#form_suggestion').hide().removeClass('d-none').fadeIn();
							$('#form_continue').hide();
						}

						$('.gevonden-afstandsverklaring *').remove();
						$.each(data, function(index, val) {
							var tr = '<tr><td>' + val.begindatum + '</td><td>' + val.einddatum + '</td><td>' + val.action + '</td></tr>';
							$('.gevonden-afstandsverklaring').append(tr);
						});
					} else {
						// Er is nog geen overlappend salaris
						toevoegenVanHisPolis.hideFormSuggestion();
					}
				});
			}
		});

		// Trigger change van begindatum als pagina geladen wordt
		$('#Begindatum').trigger('change');

	},

	// Verberg het blok met als deze zichtbaar is
	hideFormSuggestion: function() {
		$('#form_suggestion').fadeOut(100, function() {
			$('#form_continue').hide().removeClass('d-none').fadeIn();
		});
	}

};

export default toevoegenVanHisPolis;
